import colors from '@constants/colors';

export const bandColorOptions = [
	{
		name: 0,
		color: colors.indigo60,
		checked: true,
	},
	{
		name: 1,
		color: colors.indigoLavender,
		checked: false,
	},
	{
		name: 2,
		color: colors.vividViolet,
		checked: false,
	},
	{
		name: 3,
		color: colors.pacificBlue,
		checked: false,
	},
	{
		name: 4,
		color: colors.brightTurquoise,
		checked: false,
	},
	{
		name: 5,
		color: colors.limeGreen,
		checked: false,
	},
	{
		name: 6,
		color: colors.jungleGreen,
		checked: false,
	},
	{
		name: 7,
		color: colors.yellow50,
		checked: false,
	},
	{
		name: 8,
		color: colors.outrageousOrange,
		checked: false,
	},
	{
		name: 9,
		color: colors.vividCerise,
		checked: false,
	},
	{
		name: 10,
		color: colors.red60,
		checked: false,
	},
];

export const DEFAULT_COLOR_ID = '0';
